import { Button, Col, Dropdown, Menu, Row, Skeleton, Spin, Typography } from "antd";
import { Can } from "@/shared/lib/casl";
import type { Subjects } from "@shared/lib/casl";
import "./settings-users-table.scss";

export type SettingsUsersTableUser = {
  id: string;
  fullName: string;
  organization?: string;
  position?: string;
  email?: string;
  phone?: string;
  isActive?: boolean;
};

type SettingsUsersTableProps = {
  title: string;
  users?: SettingsUsersTableUser[] | null;
  isLoading?: boolean;
  isFetching?: boolean;
  onAddClick?: () => void;
  onDeleteUser?: (userId: string) => void;
  onRestoreUser?: (userId: string) => void;
  canManageAcl?: Subjects;
  addButtonText?: string;
};

export const SettingsUsersTable = ({
  title,
  users,
  isLoading,
  isFetching,
  onAddClick,
  onDeleteUser,
  onRestoreUser,
  canManageAcl,
  addButtonText = "Добавить",
}: SettingsUsersTableProps) => {
  if (isLoading) {
    return (
      <Skeleton.Node style={{ width: "100%", height: "158px", borderRadius: "16px" }} active />
    );
  }

  return (
    <div className="table-container settings-card-part">
      <div className="flex-between settings-users-table__header">
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          {title}
        </Typography.Title>
        {users && users.length > 0 && (
          isFetching ? (
            <Spin size="default" style={{ marginRight: 16, marginTop: 8 }} />
          ) : (
            <Can I="access" a={canManageAcl || "project"}>
              <Button type="link" onClick={onAddClick}>{addButtonText}</Button>
            </Can>
          )
        )}
      </div>

      {!users && <Typography.Text>Нет данных</Typography.Text>}

      {users && users.length > 0 && (
        <>
          <Row className="table-header" gutter={[16, 16]}>
            <Col span={5}><Typography.Text style={{ color: "#666666" }}>ФИО</Typography.Text></Col>
            <Col span={5}><Typography.Text style={{ color: "#666666" }}>Организация</Typography.Text></Col>
            <Col span={5}><Typography.Text style={{ color: "#666666" }}>Должность</Typography.Text></Col>
            <Col span={5}><Typography.Text style={{ color: "#666666" }}>Email</Typography.Text></Col>
            <Col span={4}><Typography.Text style={{ color: "#666666" }}>Телефон</Typography.Text></Col>
          </Row>
          {users.map((u) => (
            <Row key={u.id} className="user-row" gutter={[16, 16]} align="middle">
              <Col span={5}>{u.fullName}</Col>
              <Col span={5}>{u.organization || "-"}</Col>
              <Col span={5}>{u.position || "-"}</Col>
              <Col span={5}>{u.email || "-"}</Col>
              <Col span={3}>{u.phone || "-"}</Col>
              <Col span={1} style={{ textAlign: "right" }}>
                {(onDeleteUser || onRestoreUser) && (
                  <Can I="access" a={canManageAcl || "project"}>
                    <Dropdown
                      overlay={
                        <Menu>
                          {u.isActive !== false && onDeleteUser && (
                            <Menu.Item onClick={() => onDeleteUser(u.id)}>Удалить</Menu.Item>
                          )}
                          {u.isActive === false && onRestoreUser && (
                            <Menu.Item onClick={() => onRestoreUser(u.id)}>Восстановить право</Menu.Item>
                          )}
                        </Menu>
                      }
                      trigger={["hover"]}
                    >
                      <Button
                        type="text"
                        style={{ backgroundColor: "#EAEEF8" }}
                        icon={
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4Z" fill="#333333" />
                            <path d="M9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z" fill="#333333" />
                            <path d="M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z" fill="#333333" />
                          </svg>
                        }
                      />
                    </Dropdown>
                  </Can>
                )}
              </Col>
            </Row>
          ))}
        </>
      )}

      {users && users.length === 0 && (
        <Button type="primary" className="add-user-button" onClick={onAddClick} style={{ marginTop: 16, alignSelf: "flex-start" }}>
          {addButtonText}
        </Button>
      )}
    </div>
  );
};


